import { DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideLucideIcons } from '@lucide/angular';
import { provideEchartsCore } from 'ngx-echarts';
import { provideQuillConfig } from 'ngx-quill/config';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { APP_ICONS } from './core/constants/lucide-icons';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { httpErrorToastInterceptor } from './core/interceptors/http-error-toast.interceptor';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, httpErrorToastInterceptor])),
    { provide: LOCALE_ID, useValue: 'fr' },
    DatePipe,
    provideQuillConfig({}),
    provideEchartsCore({ echarts: () => import('echarts') }),
    provideLucideIcons(...APP_ICONS),
  ],
};
